import { useEffect, useRef, useState } from 'react';
import {
  cleanRenderedSvg,
  detectMermaidTheme,
  loadMermaid,
  prepareMermaidCode
} from './mermaid-runtime';

// Minimal inline Mermaid renderer. For pan/zoom of a single big diagram
// use DiagramView; this one is for embedding small graphs inside other
// views (Remember, etc.).
export function MermaidBlock({ code }: { code: string }) {
  const [svg, setSvg] = useState<string>('');
  const [err, setErr] = useState<string>('');
  const hostRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!code) return;
    let cancelled = false;
    (async () => {
      try {
        const theme = detectMermaidTheme(hostRef.current);
        const mermaid = await loadMermaid(theme);
        const id = 'phia-mermaid-' + Math.random().toString(36).slice(2, 9);
        const prepared = prepareMermaidCode(code);
        const { svg: rendered } = await mermaid.render(id, prepared);
        if (cancelled) return;
        setSvg(cleanRenderedSvg(rendered));
      } catch (e) {
        if (!cancelled) setErr(String(e instanceof Error ? e.message : e));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code]);

  if (err)
    return (
      <pre
        style={{
          fontSize: 12,
          color: 'var(--color-text-muted)',
          whiteSpace: 'pre-wrap',
          margin: 0
        }}
      >
        {code}
      </pre>
    );

  return (
    <div
      ref={hostRef}
      style={{ width: '100%', overflow: 'auto' }}
      // Mermaid's output is trusted because we control the source (backend).
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
